(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sundar-selective-zoom"] && !Shopify.designMode) return;
  try {
    (() => {
    const layer = document.querySelector('[data-sundar-selective-zoom]');

    if (!layer || layer.dataset.ready === 'true') return;

    const stage = layer.querySelector('[data-sundar-selective-zoom-stage]');
    const allowedSelector = [
      'media-gallery .product-media-container--image .product-media__image',
      '.lj-clean__size-guide',
      '.sundar-close-up__image',
    ].join(',');
    const pointers = new Map();
    let target = null;
    let active = false;
    let pending = false;
    let startDistance = 1;
    let startMidpointX = 0;
    let startMidpointY = 0;
    let gestureStartScale = 1;
    let gestureStartX = 0;
    let gestureStartY = 0;
    let panStartPointerX = 0;
    let panStartPointerY = 0;
    let panStartX = 0;
    let panStartY = 0;
    let targetScale = 1;
    let targetX = 0;
    let targetY = 0;
    let renderedScale = 1;
    let renderedX = 0;
    let renderedY = 0;
    let animationFrame = 0;

    layer.dataset.ready = 'true';

    const getTarget = (node) => node instanceof Element ? node.closest(allowedSelector) : null;
    const clamp = (value, minimum, maximum) => Math.min(maximum, Math.max(minimum, value));

    const getGesture = () => {
      const [first, second] = [...pointers.values()];
      return {
        distance: Math.max(1, Math.hypot(second.x - first.x, second.y - first.y)),
        midpointX: (first.x + second.x) / 2,
        midpointY: (first.y + second.y) / 2,
      };
    };

    const createPreview = () => {
      const preview = target.cloneNode(!target.matches('img'));

      preview.removeAttribute('id');
      preview.removeAttribute('tabindex');
      preview.removeAttribute('role');
      preview.removeAttribute('data-sundar-zoom-ready');

      if (preview instanceof HTMLImageElement) {
        preview.src = target.currentSrc || target.src;
        preview.removeAttribute('srcset');
        preview.removeAttribute('sizes');
        preview.alt = target.alt || '';
        preview.draggable = false;
      } else {
        preview.querySelectorAll('[id]').forEach((element) => element.removeAttribute('id'));
        preview.querySelectorAll('button, a, input, select, textarea').forEach((element) => {
          element.tabIndex = -1;
        });
      }

      stage.replaceChildren(preview);
    };

    const renderFrame = () => {
      animationFrame = 0;
      if (!active) return;

      renderedScale += (targetScale - renderedScale) * 0.28;
      renderedX += (targetX - renderedX) * 0.28;
      renderedY += (targetY - renderedY) * 0.28;
      stage.style.transform = `translate3d(${renderedX}px, ${renderedY}px, 0) scale(${renderedScale})`;

      const scaleDifference = Math.abs(targetScale - renderedScale);
      const positionDifference = Math.abs(targetX - renderedX) + Math.abs(targetY - renderedY);
      if (scaleDifference > 0.002 || positionDifference > 0.1) {
        animationFrame = requestAnimationFrame(renderFrame);
      }
    };

    const scheduleRender = () => {
      if (!animationFrame) animationFrame = requestAnimationFrame(renderFrame);
    };

    const setTargetPosition = (nextX, nextY) => {
      const horizontalLimit = Math.max(40, window.innerWidth * (targetScale - 1) * 0.48);
      const verticalLimit = Math.max(56, window.innerHeight * (targetScale - 1) * 0.48);
      targetX = clamp(nextX, -horizontalLimit, horizontalLimit);
      targetY = clamp(nextY, -verticalLimit, verticalLimit);
    };

    const activate = () => {
      if (!target || pointers.size < 2) return;
      createPreview();
      pending = false;
      targetScale = 1;
      targetX = 0;
      targetY = 0;
      renderedScale = 1;
      renderedX = 0;
      renderedY = 0;
      stage.style.transform = 'translate3d(0, 0, 0) scale(1)';
      layer.dataset.active = 'true';
      document.documentElement.classList.add('sundar-selective-zoom-active');
      active = true;
    };

    const reset = () => {
      if (animationFrame) cancelAnimationFrame(animationFrame);
      animationFrame = 0;
      active = false;
      pending = false;
      target = null;
      pointers.clear();
      layer.dataset.active = 'false';
      stage.style.transform = 'translate3d(0, 0, 0) scale(1)';
      stage.replaceChildren();
      document.documentElement.classList.remove('sundar-selective-zoom-active');
    };

    document.addEventListener('pointerdown', (event) => {
      if (event.pointerType !== 'touch') return;
      const nextTarget = active ? target : getTarget(event.target);

      if (!nextTarget) {
        if (!active) reset();
        return;
      }

      if (!target) target = nextTarget;
      if (nextTarget !== target && !target.contains(nextTarget) && !nextTarget.contains(target)) return;

      pointers.set(event.pointerId, { x: event.clientX, y: event.clientY });

      if (pointers.size === 2) {
        event.preventDefault();
        const gesture = getGesture();
        startDistance = gesture.distance;
        startMidpointX = gesture.midpointX;
        startMidpointY = gesture.midpointY;
        gestureStartScale = targetScale;
        gestureStartX = targetX;
        gestureStartY = targetY;
        pending = !active;
      }
    }, { passive: false });

    document.addEventListener('pointermove', (event) => {
      if (!pointers.has(event.pointerId)) return;
      pointers.set(event.pointerId, { x: event.clientX, y: event.clientY });

      if (pending && pointers.size === 2) {
        const gesture = getGesture();
        if (Math.abs(gesture.distance - startDistance) >= 8) activate();
      }

      if (active && pointers.size >= 2) {
        event.preventDefault();
        const gesture = getGesture();
        const pinchRatio = gesture.distance / startDistance;
        targetScale = clamp(gestureStartScale * (1 + (pinchRatio - 1) * 0.62), 1, 3);
        setTargetPosition(
          gestureStartX + (gesture.midpointX - startMidpointX) * 0.88,
          gestureStartY + (gesture.midpointY - startMidpointY) * 0.88
        );
        scheduleRender();
      } else if (active && pointers.size === 1) {
        event.preventDefault();
        const pointer = pointers.values().next().value;
        setTargetPosition(
          panStartX + (pointer.x - panStartPointerX) * 0.92,
          panStartY + (pointer.y - panStartPointerY) * 0.92
        );
        scheduleRender();
      }
    }, { passive: false });

    const endPointer = (event) => {
      if (!pointers.has(event.pointerId)) return;
      pointers.delete(event.pointerId);

      if (active && pointers.size === 1) {
        const pointer = pointers.values().next().value;
        pending = false;
        panStartPointerX = pointer.x;
        panStartPointerY = pointer.y;
        panStartX = targetX;
        panStartY = targetY;
        return;
      }

      if (pointers.size === 0) {
        reset();
      } else if (!active) {
        pending = false;
      }
    };

    document.addEventListener('pointerup', endPointer);
    document.addEventListener('pointercancel', endPointer);
    window.addEventListener('blur', reset);
  })();
  } catch(e) { console.error(e); }
})();

})();
